import {
  loggerFacet,
  ClientId,
  IMeasurementInfo,
  // IFaceted, // Missing in items-view-prefetch package. Present in items-view.
  ILogger
} from "@ms/items-view-prefetch";
import { IFaceted } from "@ms/items-view"; // Importing only the Interface. Don't actually import anyhting from items-view. Use prefetch addon
import { IEventData, ITypedScenario } from "@msteams/bridges-models-ts-logging";
import { LoggingService } from "@msteams/bridges-services-ts-logging";
import { partialRight } from "lodash";
import { markers, scenarios } from "@msteams/bridges-models-files";

export function getLoggerFacet(
  scenario: ITypedScenario<IEventData>
): IFaceted<ILogger> {
  // Start storing scenario as a global things instead of tyring to get it since items-view will only be initialized with one scenario
  return {
    ...loggerFacet.pack({
      logRenderEndTime: partialRight(logRenderEndTime, scenario),
      scenarioId: scenarios.loggerFacetScenario,
      sharingClientId: ClientId.teams
    })
  };
}

function logRenderEndTime(
  _timestamp: number,
  payload: IMeasurementInfo | undefined,
  scenario: ITypedScenario<IEventData>
) {
  /**
   * Currently items-view is not sending isFullPageLoad as true when using store to render.
   * We instead check items keys to be undefined to get this scenario
   */
  const isRenderingRootView =
    payload &&
    payload.keyChanges &&
    !payload.keyChanges.previousItemKey &&
    !payload.keyChanges.currentItemKey;
  const isFullPageLoad = payload && payload.isFullPageLoad;
  if (isFullPageLoad || isRenderingRootView) {
    /**
     * If store is created the scenario here will be specific to only the store.
     * Personal/Channel files scenario are also started when rendering the bridge so we need to stop those also
     */
    findAndStopScenario(scenarios.getPersonalFilesV2);
    findAndStopScenario(scenarios.getTeamFilesV2);
    return;
  }
  scenario.mark(markers.itemsViewRefreshed);
}

/**
 * Find scenario and stop the scenario
 * @param scenarioName
 */
function findAndStopScenario(scenarioName: string) {
  const scenario = LoggingService.findScenario(scenarioName);
  if (scenario) {
    scenario.stop();
  }
}
